module.exports = __webpack_public_path__ + "media/f03.2592873d.mp4";